import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Row = styled.button<{
  backgroundHoverColor: string;
  defaultTextColor: string;
  hoverTextColor: string;
}>`
  background-color: transparent;
  border: 0;
  border-radius: 6px;
  color: ${({ defaultTextColor }) => defaultTextColor};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 5px;
  text-decoration: none;
  width: 100px;

  &:hover {
    background-color: ${({ backgroundHoverColor }) => backgroundHoverColor};
    color: ${({ hoverTextColor }) => hoverTextColor};
  }
`;

export const RowIcon = styled.div`
  height: 18px;
  width: 18px;
`;
export const RowLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
`;
